import CONFIG from 'config';
import { CAMERA_DEVICE_API, PREFIX_API } from 'constants/api.const';
import {
  IS_MULTIPLE_CAMERA_STORAGE_KEY,
  WEBCAM_STORAGE_KEY,
} from 'constants/common.const';
import { PROCESSED_URL_PATH } from 'constants/file.const';
import { QUERY_STRING } from 'constants/route.const';
import { CameraModel } from 'models/photo/camera.model';
import qs from 'query-string';
import { includes } from 'lodash';
import { getSessionStorage } from './common.helper';

/**
 * So chuỗi với số
 *
 * @category string, number
 * @param any types to compare
 * @param any types to compare
 * @returns Returns boolean of compare.
 * @example
 *
 * isEqualVal(1, "1") => true
 * isEqualVal(0, "0") => true
 * isEqualVal(0, "") => false
 * isEqualVal(0, "") => false
 * isEqualVal(1, "abc") => false
 * isEqualVal("abc", "abc") => true
 *
 */
function stringifyUrl(obj: any, prefix: string = ''): string {
  const str = [];
  let p;
  for (p in obj) {
    if (obj[p]) {
      const k = prefix ? `${prefix}[${p}]` : p;
      const v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? stringifyUrl(v, k)
          : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
      );
    }
  }
  return str.join('&');
}
function isEqualPath(
  v1: string | null | undefined,
  v2: string | null | undefined,
): boolean {
  return v1 === v2 || `${v1}/` === v2 || v1 === `${v2}/`;
}

function aSlash(path: string = '/'): string {
  return path?.[0] === '/' ? path : `/${path}`;
}

/**
 * Url file ảnh asset theme, layout, ...
 *
 * @category string
 * @param string? types
 * @returns string
 *
 */
function imageUrl(path: string = '/'): string {
  return `${CONFIG.REACT_APP_PUBLIC_URL}${aSlash(path)}`;
}

/**
 * Url file ảnh asset theme, layout, ...
 *
 * @category string
 * @param string? types
 * @returns string
 *
 */
function resourceUrl(path: string = '/'): string {
  if (includes(path, 'https://') || includes(path, 'http://')) return path;

  return `${CONFIG.REACT_APP_PUBLIC_URL}/api/file/image/resource${aSlash(
    path,
  )}`;
}

/**
 * Url file ảnh được chụp với từng transaction
 *
 * @category all string
 * @returns string.
 */
function processedImageUrl(
  transactionId: string,
  processedImgFileName: string = '',
  imageHash: number | string = '',
): string {
  if (!transactionId || !processedImgFileName) return '';

  return imageUrl(
    `${PROCESSED_URL_PATH}/${transactionId}/${processedImgFileName}?${imageHash}`,
  );
}

/**
 * Url live view của camera chụp ảnh
 *
 * @category all string
 * @returns string.
 */
// Todo: canon
export function liveViewUrl(
  sessionId: CameraModel['ID'],
  ratio: number | number | undefined,
  hash: number | string | undefined = '',
): string {
  return imageUrl(
    `/${PREFIX_API.API}/${getCamDeviceApi()}/liveview?${qs.stringify({
      id: sessionId,
      ratio: ratio ?? '',
      hash,
    })}`,
  );
}

function getCamDeviceApi(): string {
  const isUseWebCam =
    !!qs.parseUrl(window?.location?.href)?.query?.[QUERY_STRING.CAM_DEVICE] ||
    !!getSessionStorage(WEBCAM_STORAGE_KEY);

  // booth sử dụng multiple camera
  const isMultiCamera = !!getSessionStorage(IS_MULTIPLE_CAMERA_STORAGE_KEY);

  const canonPrefix = isMultiCamera
    ? CAMERA_DEVICE_API.CANON_PLUS
    : CAMERA_DEVICE_API.CANON;

  return isUseWebCam ? CAMERA_DEVICE_API.WEBCAM : canonPrefix;
}

export {
  aSlash,
  getCamDeviceApi,
  imageUrl,
  isEqualPath,
  processedImageUrl,
  resourceUrl,
  stringifyUrl,
};
